// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSwitch-HelperText_cls1__mS1H0","cls2":"VeloSwitch-HelperText_cls2__Kw5k2 VeloSwitch-HelperText_cls1__mS1H0"};